// removed by extract-text-webpack-plugin
module.exports = {"component":"_22x_bx0t6bh2aflWF1XttH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/PaymentButton/paymentButton.css
// module id = 1074
// module chunks = 2